import { render, staticRenderFns } from "./AdminSettings.vue?vue&type=template&id=4c1060dc&"
import script from "./AdminSettings.vue?vue&type=script&lang=js&"
export * from "./AdminSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/suspicious_login/suspicious_login/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c1060dc')) {
      api.createRecord('4c1060dc', component.options)
    } else {
      api.reload('4c1060dc', component.options)
    }
    module.hot.accept("./AdminSettings.vue?vue&type=template&id=4c1060dc&", function () {
      api.rerender('4c1060dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AdminSettings.vue"
export default component.exports